module.exports = __webpack_public_path__ + "img/fujin.8dc47b82.png";